/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reseller information
 * @export
 * @interface GetResellerInfo200ResponseReseller
 */
export interface GetResellerInfo200ResponseReseller {
    /**
     * 
     */
    uuid?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    invoiced?: boolean;
}

/**
 * Check if a given object implements the GetResellerInfo200ResponseReseller interface.
 */
export function instanceOfGetResellerInfo200ResponseReseller(value: object): value is GetResellerInfo200ResponseReseller {
    return true;
}

export function GetResellerInfo200ResponseResellerFromJSON(json: any): GetResellerInfo200ResponseReseller {
    return GetResellerInfo200ResponseResellerFromJSONTyped(json, false);
}

export function GetResellerInfo200ResponseResellerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetResellerInfo200ResponseReseller {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'name': json['name'] == null ? undefined : json['name'],
        'invoiced': json['invoiced'] == null ? undefined : json['invoiced'],
    };
}

export function GetResellerInfo200ResponseResellerToJSON(json: any): GetResellerInfo200ResponseReseller {
    return GetResellerInfo200ResponseResellerToJSONTyped(json, false);
}

export function GetResellerInfo200ResponseResellerToJSONTyped(value?: GetResellerInfo200ResponseReseller | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'name': value['name'],
        'invoiced': value['invoiced'],
    };
}

